import {
  MENU_SET_CLASSNAMES,
  MENU_CONTAINER_ADD_CLASSNAME,
  MENU_CLICK_MOBILE_MENU,
  MENU_CHANGE_DEFAULT_CLASSES
} from "Constants/actionTypes";

import {
  defaultMenuType,
  subHiddenBreakpoint,
  menuHiddenBreakpoint
} from "Constants/defaultValues";

import type { UnknownAction } from "redux";

const INIT_STATE = {
  containerClassnames: defaultMenuType,
  subHiddenBreakpoint,
  menuHiddenBreakpoint,
  menuClickCount: 0
};

export default function menuReducer(
  state: typeof INIT_STATE = INIT_STATE,
  action: UnknownAction
): typeof INIT_STATE {
  switch (action.type) {
    case MENU_SET_CLASSNAMES: {
      const a = action as {
        type: typeof MENU_SET_CLASSNAMES;
        payload: {
          containerClassnames: string;
          menuClickCount: number;
        };
      };
      return Object.assign({}, state, {
        containerClassnames: a.payload.containerClassnames,
        menuClickCount: a.payload.menuClickCount
      });
    }

    case MENU_CLICK_MOBILE_MENU: {
      const a = action as {
        type: typeof MENU_CLICK_MOBILE_MENU;
        payload: {
          containerClassnames: string;
          menuClickCount: number;
        };
      };
      return Object.assign({}, state, {
        containerClassnames: a.payload.containerClassnames,
        menuClickCount: a.payload.menuClickCount
      });
    }

    case MENU_CONTAINER_ADD_CLASSNAME: {
      const a = action as {
        type: typeof MENU_CONTAINER_ADD_CLASSNAME;
        payload: string;
      };
      return Object.assign({}, state, {
        containerClassnames: a.payload
      });
    }

    case MENU_CHANGE_DEFAULT_CLASSES: {
      const a = action as {
        type: typeof MENU_CHANGE_DEFAULT_CLASSES;
        payload: string;
      };
      return Object.assign({}, state, {
        containerClassnames: a.payload
      });
    }

    default:
      return { ...state };
  }
}
